<script setup lang="ts">
import { IonButton } from '@ionic/vue'
import type { Chat, StarOperation } from '@/types'
import { userService } from '@/services/user'
import { useUserStore } from '@/store/user'
import StarIcon from '@/components/svg/StarIcon.vue'
import FilledStarIcon from '@/components/svg/FilledStarIcon.vue'

interface Props {
  chat: Chat
  isFavorite: boolean
}
defineProps<Props>()
const userStore = useUserStore()

/**
 * handle favorite universe
 * TODO: Move it to chatsStore, combine with toggleIsStared
 * @param operation add or remove
 * @param chat Chat
 */
async function handleStarClick(operation: StarOperation, chat?: Chat) {
  if (chat) {
    try {
      await userService.favoriteUniverseOperations({
        universeId: chat.universe.universeId,
        operate: operation,
      })
      chat.isStared = operation === 'add'
      await userStore.getUserInfo()
    }
    catch (error) {
      console.error(error)
    }
  }
}
</script>

<template>
  <ion-button
    size="small"
    fill="clear"
    @click.stop="
      () => {
        handleStarClick(isFavorite ? 'remove' : 'add', chat)
      }
    "
  >
    <filled-star-icon v-if="chat?.isStared" />
    <star-icon v-else />
  </ion-button>
</template>
